<script lang="ts" setup>
import AppIcon from '@layer/components/elements/AppIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex min-h-screen">
    <div class="bg-gray-50 hidden w-2/6 flex-col lg:flex">
      <div class="p-8">
        <slot name="logo" />
      </div>

      <div class="mt-16">
        <slot name="stepper" />
      </div>
    </div>

    <div class="flex w-full flex-col lg:w-3/4">
      <div class="flex justify-end p-6">
        <NuxtLink
          to="/auth/login"
          class="flex items-center gap-2 rounded-md px-2 py-2 text-base text-black hover:underline"
        >
          <AppIcon name="fa6-solid:arrow-left" size="sm" color="basics-icon" />
          <span>{{ t('common.back_to_login') }}</span>
        </NuxtLink>
      </div>
      <header class="flex flex-col justify-center px-4 pt-8">
        <div class="container mx-auto max-w-2xl">
          <slot name="header" />
        </div>
      </header>

      <main class="flex-1 px-4">
        <div class="container mx-auto max-w-2xl">
          <div class="my-6">
            <div class="w-full">
              <slot />
            </div>
          </div>
        </div>
      </main>

      <footer class="w-full">
        <div
          class="mx-auto flex w-full items-center justify-center px-4 py-12 lg:w-1/2 lg:pb-16 lg:pt-8"
        >
          <slot name="footer" />
        </div>

        <div class="w-full">
          <slot name="footerBottom" />
        </div>
      </footer>
    </div>
  </div>
</template>
